import * as React from "react";
import { styled } from "@mui/system";
import { NavLink } from "react-router-dom";
import { observer } from "mobx-react";
import { PlatformContext, PlatformStore } from "@upptic/module-directory";
import { Menu, MenuItem } from "@mui/material";
import { Icon } from "components";
import { getMobileTopBarNavigationElements } from "../constants/topBarNavigationElements";

type MobileTopBarProps = {
  open: boolean;
  anchorEl?: any;
  handleClose?: () => void;
};

// -- COMPONENT
export const MobileTopBarNavMenu = observer(
  ({ open, anchorEl, handleClose }: MobileTopBarProps): JSX.Element => {
    const platformStore = React.useContext<PlatformStore>(PlatformContext);
    const availableElements = getMobileTopBarNavigationElements(
      platformStore.currentClient?.code,
    ).filter(({ permission }) =>
      platformStore.currentUserFrontendPermissions.includes(permission),
    );
    const createClassName = (singleElement: string) => {
      const product =
        singleElement === "Growth" ? "ua" : singleElement.toLowerCase();
      return `product-icon-${product}`;
    };

    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {availableElements.map((singleElement) => {
          const IconComponent = singleElement.component;
          return (
            <MenuItem key={singleElement.url}>
              <Element
                to={singleElement.url}
                key={singleElement.url}
                className={createClassName(singleElement?.label)}
                onClick={handleClose}
              >
                <ElementWrapper key={singleElement.label}>
                  <ContentWrapper>
                    {singleElement.icon ? (
                      <ProductIcon icon={singleElement.icon} />
                    ) : null}
                    {singleElement.component ? (
                      <IconComponent
                        style={{ width: "18px", marginRight: 10 }}
                      />
                    ) : null}
                    {singleElement.logo ? (
                      <Logo logo={singleElement.logo} />
                    ) : null}
                    <TextLabel>{singleElement.label}</TextLabel>
                  </ContentWrapper>
                </ElementWrapper>
              </Element>
            </MenuItem>
          );
        })}
      </Menu>
    );
  },
);

const Element = styled(NavLink)`
  font-weight: 600;

  color: ${(props: any) => props.theme.colors.lightGrey};
  svg {
    fill: ${(props: any) => props.theme.colors.lightGrey};
  }

  &:hover {
    color: ${(props: any) => props.theme.colors.white};

    text-decoration: none;
  }

  &:hover svg {
    fill: ${(props: any) => props.theme.colors.white};
  }

  &:not(:last-of-type) {
    margin-right: 15px;
  }

  &.active {
    color: ${(props: any) => props.theme.colors.purple};
  }

  &.active svg {
    fill: ${(props: any) => props.theme.colors.purple};
  }
`;

const ElementWrapper = styled("div")`
  height: 35px;
  width: 140px;
  display: flex;
  align-items: center;
`;

const ContentWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProductIcon = styled(Icon)`
  height: 24px;
  width: 24px;
  margin-right: 10px;
`;

const Logo = styled("div")<{ logo: any }>`
  height: 18px;
  width: 18px;
  margin-right: 10px;
  background-image: url(${(props: any) => props.logo});
  background-repeat: no-repeat;
  background-size: contain;
`;

const TextLabel = styled("span")`
  height: 21px;
  display: flex;
  align-items: flex-start;
`;
